import { HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable, finalize } from 'rxjs';
import { LoadingSpinnerService } from '../../services/common/loading-spinner.service';
import { SKIP_LOADING_SPINNER } from '../errors/http-context-tokens';

export const loadingInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
  const loadingSpinnerService = inject(LoadingSpinnerService);

  // Skip loading spinner for background/async requests
  if (req.context.get(SKIP_LOADING_SPINNER)) {
    return next(req);
  }

  loadingSpinnerService.beginRequest();

  return next(req).pipe(
    finalize(() => loadingSpinnerService.endRequest())
  );
};